exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "h1[data-v-35ca387f],h2[data-v-35ca387f]{font-weight:400}ul[data-v-35ca387f]{list-style-type:none;padding:0}li[data-v-35ca387f]{display:inline-block;margin:0 10px}a[data-v-35ca387f]{color:#42b983}", "", {"version":3,"sources":["/Users/oleg/dev/flask/flaskvue/frontend/src/components/HelloWorld.vue"],"names":[],"mappings":"AACA,wCACE,eAAoB,CACrB,AACD,oBACE,qBAAsB,AACtB,SAAW,CACZ,AACD,oBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,mBACE,aAAe,CAChB","file":"HelloWorld.vue","sourcesContent":["\nh1[data-v-35ca387f], h2[data-v-35ca387f] {\n  font-weight: normal;\n}\nul[data-v-35ca387f] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-35ca387f] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-35ca387f] {\n  color: #42b983;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35ca387f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HelloWorld.vue
// module id = +8MP
// module chunks = 1